import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetHighlightRow, SheetHighlight, formatText, formatDate, formatCurrency, formatBoolean, buildEntornoLaboralProps, formatDecimal } from "../SheetLayout";

const Regularizacion: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const regularizacionId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getRegularization, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getRegularization(userId, prestacionId, regularizacionId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Regularización"
        icon="sliders"
        pills={<>
          <SheetPill label="Descripción" value={formatText(d.tipoGastoGeneralDescripcion)} />
          <SheetPill label="Pagado" value={formatBoolean(d.estaPagado)} />
        </>}
      />

      <SheetSection title="Datos Regularización" icon="file-text">
        <SheetGrid>
          <SheetField label="Descripción"              value={formatText(d.tipoGastoGeneralDescripcion)} wide />
          <SheetField label="Pagado"                   value={formatBoolean(d.estaPagado)} />
          <SheetField label="Fecha Periodo Inicial"    value={formatDate(d.fechaPeriodoInicial)} />
          <SheetField label="Fecha Periodo Final"      value={formatDate(d.fechaPeriodoFinal)} />
          <SheetField label="Fecha Traspaso al Banco"  value={formatDate(d.fechaTraspasoABanco)} />
          <SheetField label="Fecha de Pago"            value={formatDate(d.fechaPago)} />
          <SheetField label="IPREM Diario"             value={formatCurrency(d.IPREM_Diario)} />
          <SheetField label="Base Reguladora Diaria"   value={formatCurrency(d.baseReguladoraDiaria)} />
          <SheetField label="Cuota Obrera"             value={formatDecimal(d.cuotaObrera)} />
          <SheetField label="Días Devengados"          value={formatText(d.diasDevengados)} />
          <SheetField label="Importe Cuota Obrera"     value={formatCurrency(d.importeCuotaObrera)} />
          <SheetField label="Importe Retenciones"      value={formatCurrency(d.importeRetenciones)} />
          <SheetField label="% Horas Trabajadas"       value={formatDecimal(d.porcentajeHorasTrabajadas)} />
          <SheetField label="% IT"                     value={formatDecimal(d.porcentajeIT)} />
        </SheetGrid>

        <SheetHighlightRow>
          <SheetHighlight label="Bruto"      value={formatCurrency(d.bruto)}    variant="blue" />
          <SheetHighlight label="Neto"       value={formatCurrency(d.neto)}     variant="green" />
          <SheetHighlight label="Retención %" value={formatText(d.retencion)}   variant="amber" />
        </SheetHighlightRow>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default Regularizacion;
